import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import EfAccordionInfoImg, { EfAccordionInfoImgType } from '@elem/ui/ef-accordion-Info-img';
import { PageNavType } from '../PageNav';
import styles from './index.module.scss';
import { Icondp, IconInfo, IconShopy, IconUsers, IconX1, IconX2, IconX3, IconX4 } from './Icons';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

export default function TheComp() {
    const { locale = 'eu' } = getLocal();
    const IS_UK_SITE = locale === 'uk';

    const { t } = useLang('theProduct.WhyChoose');
    const { t: item1 } = useLang('theProduct.WhyChoose.item1');
    const { t: item2 } = useLang('theProduct.WhyChoose.item2');
    const { t: item3 } = useLang('theProduct.WhyChoose.item3');
    const list: EfAccordionInfoImgType[] = [
        {
            pc: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741156044120/10_1.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741157502685/10_1%20(1).png',
            pad: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741156192710/10_1.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741082262746/why-pad-1.jpg',
            h5: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741156212678/10_1.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741082262270/why-pc-1.jpg',
            title: item1('title'),
            desc: item1('desc'),
            grid: [
                {
                    icon: IconUsers,
                    text: item1('label_1'),
                },
                {
                    icon: IconShopy,
                    text: item1('label_2'),
                },
            ],
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1732501951214/WhyChoose-2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1732501951805/WhyChoose-h5-2.jpg',
            title: item2('title'),
            desc: item2('desc'),
            grid: [
                {
                    icon: IconX1,
                    text: item2('label_1'),
                },
                {
                    icon: IconX2,
                    text: item2('label_2'),
                },
                {
                    icon: IconX3,
                    text: item2('label_3'),
                },
                {
                    icon: IconX4,
                    text: item2('label_4'),
                },
            ],
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1732501951418/WhyChoose-3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1732501952004/WhyChoose-h5-3.jpg',
            title: item3('title'),
            desc: item3('desc'),
            grid: [
                {
                    icon: IconInfo,
                    text: item3('label_1'),
                },
                {
                    icon: Icondp,
                    text: item3('label_2'),
                },
            ],
        },
    ];
    return (
        <div className={styles.TheComp} id={PageNavType.Why}>
            <EfSpec />
            <EfTitle>{t('title')}</EfTitle>
            <EfAccordionInfoImg className="why-choose-info" moduleTitle={t('title')} list={list} />
        </div>
    );
}
